/**
 * Handoff hub-app-front → produto: o Hub abre o app com ?hubToken=<accessToken>.
 */

export function readHubTokenFromUrl(
    search = typeof window !== 'undefined' ? window.location.search : '',
): string | null {
    const token = new URLSearchParams(search || '').get('hubToken')?.trim() ?? '';
    return token || null;
}

/** Remove hubToken da query e mantém o restante da URL. */
export function stripHubTokenFromUrl(pathname: string, search: string, hash: string): string {
    const params = new URLSearchParams(search || '');
    params.delete('hubToken');
    const qs = params.toString();
    return pathname + (qs ? `?${qs}` : '') + (hash || '');
}

export function hasHubTokenInUrl(
    search = typeof window !== 'undefined' ? window.location.search : '',
): boolean {
    return Boolean(readHubTokenFromUrl(search));
}
